import {
  Controller,
  ControllerFieldState,
  ControllerRenderProps,
  UseFormStateReturn,
  FieldValues,
} from 'react-hook-form';

import { BaseInputProps } from '../../../types';
import { ErrorMessage } from '../../Typhography/ErrorMessage';
import { RelativeInputDiv } from '../../Typhography/RelativeInputDiv';

import { SelectMulti, SelectMultiProps } from './SelectMulti';

interface InputProps<TFieldValues extends FieldValues> extends BaseInputProps<TFieldValues> {
  placeholder?: string;
  values: any[] | undefined;
  labelAdditionalDescription?: string;
  type?: 'text' | 'textarea' | 'password';
  style?: any;
  includeCustomSearch?: SelectMultiProps['includeCustomSearch'];
  renderRightComponent?: () => React.ReactElement | null;
  onKeyPress?: (event?: any) => void;
  isClearable?: boolean;
  onChange?: SelectMultiProps['onChange'];
}

export function SelectMultiForm<TFieldValues extends FieldValues>({
  placeholder,
  control,
  disabled,
  error,
  name,
  width,
  mobWidth,
  defaultValue = '',
  values,
  renderRightComponent,
  style = {},
  margin = '',
  onKeyPress,
  includeCustomSearch,
  isClearable,
  onChange,
  ...rest
}: InputProps<TFieldValues>) {
  const customOnChange = onChange;
  const errorMessage = error ? error.message || error.value.message : '';

  const renderControllerSelect = ({
    field: { onChange, value },
  }: {
    field: ControllerRenderProps<TFieldValues>;
    fieldState: ControllerFieldState;
    formState: UseFormStateReturn<TFieldValues>;
  }) => {
    return (
      <RelativeInputDiv width={width} mobWidth={mobWidth} margin={margin}>
        <SelectMulti
          {...rest}
          options={values}
          value={value}
          placeholder={placeholder}
          onChange={(value) => {
            onChange(value);
            customOnChange && customOnChange(value);
          }}
          isDisabled={disabled}
          maxMenuHeight={130}
          style={style}
          width={width}
          onKeyPress={onKeyPress}
          includeCustomSearch={includeCustomSearch}
          isClearable={isClearable}
        />
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </RelativeInputDiv>
    );
  };

  return (
    <>
      {renderRightComponent ? <div>{renderRightComponent?.()}</div> : <></>}
      <Controller
        control={control}
        name={name}
        render={renderControllerSelect}
        defaultValue={defaultValue}
      />
    </>
  );
}
